import "./styles/style.css";
import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Introduction from "./components/pages-flow/Introduction";
import Icons from "./components/Icons";
import LoginPage from "./components/Login";
import HistoryPage from "./components/HistoryPage";
import {
  addProject,
  getAllProjects,
  updateProject,
  deleteProject,
} from "./db";

function App() {
  const [currentPage, setCurrentPage] = useState("form");
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [forceReset, setForceReset] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [history, setHistory] = useState([]);
  const [currentProject, setCurrentProject] = useState(null);
  const [editingProjectId, setEditingProjectId] = useState(null);

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    const projects = await getAllProjects();
    setHistory(projects);
  };

  const handleNavigate = (page) => {
    setCurrentPage(page);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleSaveProject = async (projectName, projectData) => {
    const project = {
      name: projectName || "Unnamed project",
      date: new Date().toISOString(),
      data: projectData,
    };

    if (editingProjectId !== null) {
      await updateProject(editingProjectId, { ...project, id: editingProjectId });
      setEditingProjectId(null);
    } else {
      await addProject(project);
    }
    loadProjects();
  };

  const handleDuplicate = async (project, newName) => {
    const newProject = {
      name: newName,
      date: new Date().toISOString(),
      data: project.data,
    };
    await addProject(newProject);
    loadProjects();
  };

  const handleModify = (project) => {
    setCurrentProject(project);
    setEditingProjectId(project.id);
    setCurrentPage("form");
  };

  const handleDelete = async (id) => {
    await deleteProject(id);
    loadProjects();
  };

  if (!isLoggedIn) {
    return <LoginPage onLogin={handleLoginSuccess} />;
  }

  return (
    <div>
      <Navbar
        onNavigate={handleNavigate}
        onHomeClick={() => {
          if (currentPage === "form") {
            setShowConfirmDialog(true);
          } else {
            setForceReset(true);
            setCurrentPage("form");
          }
        }}
      />
      {currentPage === "form" && (
        <Introduction
          showConfirmDialog={showConfirmDialog}
          onConfirmDialogClose={(confirmed) => {
            setShowConfirmDialog(false);
            if (confirmed) {
              setForceReset(true);
            }
          }}
          forceReset={forceReset}
          onForceResetHandled={() => setForceReset(false)}
          onSaveProject={handleSaveProject}
          projectToEdit={currentProject}
        />
      )}
      {currentPage === "icons" && <Icons />}
      {currentPage === "history" && (
        <HistoryPage
          history={history}
          onDuplicate={handleDuplicate}
          onModify={handleModify}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
}

export default App;
